import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { HelpCircle } from "lucide-react";

const FAQS = [
  {
    q: "Qual valor de um guincho em Araçoiaba da Serra?",
    a: "O valor varia conforme a distância e tipo do veículo. A Refúgio Guincho cobre qualquer orçamento da concorrência na região de Araçoiaba da Serra, Sorocaba e Votorantim. Fale com a gente no WhatsApp ou ligue (15) 99850-4951 para um orçamento em menos de 1 minuto — sem compromisso.",
  },
  {
    q: "Vocês atendem Sorocaba 24 horas?",
    a: "Sim! Atendemos Sorocaba, Votorantim, Salto de Pirapora, Iperó, Capela do Alto, Alumínio, Mairinque, São Roque e toda a região metropolitana 24 horas por dia, 7 dias por semana, inclusive feriados e madrugada.",
  },
  {
    q: "Fazem guincho para moto?",
    a: "Sim, temos equipamento específico para transporte de motos de todas as cilindradas, com calços e cintas apropriadas. Trabalhamos com motos esportivas, naked, custom e scooters — sem risco de avarias.",
  },
  {
    q: "Fazem socorro mecânico na hora?",
    a: "Sim. Vamos até você, rebocamos seu veículo com o Guincho até nosso Centro Automotivo com preço diferenciado e fazemos orçamento gratuito do reparo do seu veículo.",
  },
  {
    q: "Levam o veículo para oficina?",
    a: "Sim. Temos centro automotivo próprio em Araçoiaba da Serra. Fazemos a remoção e levamos direto para diagnóstico com orçamento gratuito, pagando apenas um preço diferenciado da remoção do seu veículo até nosso Centro Automotivo, economizando tempo e dinheiro. Você tem serviço completo em um só lugar.",
  },
  {
    q: "Cobrem orçamento de outro guincho?",
    a: "Cobrimos qualquer orçamento comprovado da concorrência. Nosso compromisso é oferecer o menor preço do mercado com atendimento rápido, seguro e humanizado. Mande o orçamento que você recebeu — e cobrimos.",
  },
  {
    q: "Quais formas de pagamento vocês aceitam?",
    a: "Aceitamos dinheiro, PIX, cartões de débito e crédito, com parcelamento facilitado. Sem surpresa no valor final — tudo combinado antes do atendimento.",
  },
  {
    q: "Quanto tempo leva para o guincho chegar?",
    a: "Em Araçoiaba da Serra o tempo médio é de 5 a 20 minutos. Em cidades vizinhas como Sorocaba e Votorantim, geralmente entre 20 e 40 minutos, dependendo do trânsito e da localização exata.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="bg-[#0A0A0A] py-16 md:py-24">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 bg-[#E50914] px-3 py-1 mb-4">
            <HelpCircle className="w-4 h-4 text-white" />
            <span className="font-anton text-sm uppercase tracking-widest text-white">Dúvidas Frequentes</span>
          </div>
          <h2 className="font-anton text-4xl md:text-6xl uppercase text-white leading-[0.95]">
            Perguntas <span className="text-[#E50914]">Rápidas</span>
          </h2>
          <p className="font-work text-zinc-300 mt-4">
            Respostas diretas para quem precisa decidir na hora.
          </p>
        </div>

        <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              data-testid={`faq-item-${i}`}
              className="bg-[#171717] border-2 border-zinc-800 data-[state=open]:border-[#E50914] px-5 md:px-6 transition-colors"
            >
              <AccordionTrigger className="font-anton text-left text-lg md:text-xl uppercase text-white hover:text-[#E50914] hover:no-underline py-5 tracking-wide">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="font-work text-zinc-300 text-sm md:text-base leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
